import { render } from "./Ticket_Select.vue?vue&type=template&id=c0450e34&scoped=true"
import script from "./Ticket_Select.vue?vue&type=script&lang=js"
export * from "./Ticket_Select.vue?vue&type=script&lang=js"

import "./Ticket_Select.vue?vue&type=style&index=0&id=c0450e34&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0450e34"]])

export default __exports__